import axios from 'axios';
import { all, call, fork, put, takeLatest } from 'redux-saga/effects';
import {
  axes,
  deleteAxeError,
  deleteAxeSuccess,
  editAxeError,
  editAxeSuccess,
  generatePlatesError,
  generatePlatesSuccess,
  getAxes,
  getAxesError,
  getAxesSuccess,
  insertNewAxeError,
  insertNewAxeSuccess,
} from './actions';
import {
  DELETE_AXE,
  EDIT_AXE,
  GENERATE_PLATES,
  GET_AXES,
  INSERT_NEW_AXE,
} from 'redux/actions';

const getAxesAsync = async (page = 1) => {
  const response = await axios.get(`/area-plates?page=${page}`);
  return response.data;
};

const insertNewAxeAsync = async (payload) => {
  const response = await axios.post('/area-plates', payload);
  return response.data;
};

const editAxeAsync = async ({ id, ...rest }) => {
  const response = await axios.put(`/area-plates/${id}`, rest);
  return response.data;
};

const deleteAxeAsync = async ({ id }) => {
  const response = await axios.delete(`/area-plates/${id}`);
  return response.data;
};

const generatePlatesAsync = async () => {
  const response = await axios.post('/area-plates/generate-area-plate-axis');
  return response.data;
};

function* errorHandler(error, errorAction) {
  try {
    if ('response' in error) {
      const response = error.response;

      if (response?.data?.message) {
        yield put(errorAction(response.data.message));
        return;
      }

      if (response?.data?.errors) {
        const keys = Object.keys(response.data.errors);
        for (const key of keys) {
          const message =
            response.data.errors[key][0] || 'خطا در انجام عملیات.';
          yield put(errorAction(message));
        }
        return;
      }
    }

    yield put(
      errorAction('خطا در ارتباط با سرور. لطفاً اتصال خود را بررسی کنید.')
    );
  } catch {
    yield put(errorAction('خطایی در انجام فرآیند رخ داد.'));
  }
}

function* getAxesSaga({ payload }) {
  try {
    const { page } = payload;
    const data = yield call(getAxesAsync, page);
    yield put(axes(data));
    yield put(getAxesSuccess('محور‌ها با موفقیت دریافت شدند.'));
  } catch (error) {
    yield call(errorHandler, error, getAxesError);
  }
}

function* insertNewAxeSaga({ payload }) {
  try {
    yield call(insertNewAxeAsync, payload);
    yield put(insertNewAxeSuccess('محور جدید با موفقیت افزوده شد.'));
    yield put(getAxes());
  } catch (error) {
    yield call(errorHandler, error, insertNewAxeError);
  }
}

function* editAxeSaga({ payload }) {
  try {
    yield call(editAxeAsync, payload);
    yield put(editAxeSuccess('محور با موفقیت ویرایش شد.'));
    yield put(getAxes());
  } catch (error) {
    yield call(errorHandler, error, editAxeError);
  }
}

function* deleteAxeSaga({ payload }) {
  try {
    yield call(deleteAxeAsync, payload);
    yield put(deleteAxeSuccess('محور با موفقیت حذف شد.'));
    yield put(getAxes());
  } catch (error) {
    yield call(errorHandler, error, deleteAxeError);
  }
}

function* generatePlatesSaga() {
  try {
    yield call(generatePlatesAsync);
    yield put(generatePlatesSuccess('پلاک‌ها با موفقیت تولید شدند.'));
  } catch (error) {
    yield call(errorHandler, error, generatePlatesError);
  }
}

function* watchGetAxes() {
  yield takeLatest(GET_AXES, getAxesSaga);
}

function* watchInsertNewAxe() {
  yield takeLatest(INSERT_NEW_AXE, insertNewAxeSaga);
}

function* watchEditAxe() {
  yield takeLatest(EDIT_AXE, editAxeSaga);
}

function* watchDeleteAxe() {
  yield takeLatest(DELETE_AXE, deleteAxeSaga);
}

function* watchGeneratePlates() {
  yield takeLatest(GENERATE_PLATES, generatePlatesSaga);
}

export default function* rootSaga() {
  yield all([
    fork(watchGetAxes),
    fork(watchInsertNewAxe),
    fork(watchDeleteAxe),
    fork(watchEditAxe),
    fork(watchGeneratePlates),
  ]);
}
